import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  isLoaded: false,
  isGtag: false,
  data: {
    auth: false,
    login: null,
    name: null,
    balance: null,
    network: null,
    address: null,
    eventServer: null,
    fullNode: null,
    solidityNode: null,
    timer: null,
  }
}

const wallet = createSlice({
  name: 'wallet',
  initialState,
  reducers: {
    setIsLoaded: (state, action) => {
      state.isLoaded = action.payload
    },
    setIsGtag: (state, action) => {
      state.isGtag = action.payload
    },
    setWallet: (state, action) => {
      state.data = action.payload
    },
  }
})

const { actions, reducer } = wallet

export const {
  setIsLoaded,
  setIsGtag,
  setWallet,
} = actions

export default reducer